module.exports = __webpack_public_path__ + "static/media/virtusa.2029d1b2.png";